import { useNavigate } from "react-router-dom";
import DataViewPage from "../controls/DataViewPage";
import SideBySideLayout from "../controls/SideBySideLayout";
import ViewPage from "../controls/ViewPage";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/userSlice";
import Icon from "../../assets/icons/Icon";
import CustomTable from "../controls/CustomTable";
import { useEffect, useState } from "react";
import Button from "../controls/Button";
import ChatWidget from "../controls/ChatWidget";
import { toast } from "react-toastify";
import { fetchGetStarted } from "../../api/GetStartedApi";
import Loading from "../controls/Loading";
import { ExternalLink } from "lucide-react";
import { isMobileView } from "../controls/CommonFunctions";

const GetStarted = () => {
    const navigate = useNavigate();
    const user = useSelector(selectUser);
    const store = useSelector((state) => state.store.store);
    console.log("user", user);
    const [selectedRowId, setSelectedRowId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [steps, setSteps] = useState([]);
      const [isOpen, setIsOpen] = useState(false);
      const [isAllStepCompleted,setIsAllStepCompleted]=useState(false);

    const fetchGetStartedData = async () => {
        setLoading(true);
        try {
            const response = await fetchGetStarted(store?.key);
          if (response.code === "0") {
            console.log("response", response);

            const updatedSteps = [
                { step: "Store Setup", status: response.storeStatus === "completed" ? "completed" : "pending", id: 1 },
                { step: "Tax Setup", status: response.taxStatus === "completed" ? "completed" : "pending", id: 2 },
                     { step: "Setup Catalogue", status: response.productStatus === "completed" ? "completed" : "pending", id: 3 },
                // { step: "Setup Catalogue", status: response.categoryStatus === "completed" && response.productStatus === "completed" ? "completed" : "pending", id: 3 },
                { step: "Stock up your Inventory", status: response.inventoryStatus === "completed" ? "completed" : "pending", id: 4 },
                { step: "Print Setup", status: response.printStatus === "completed" && response.barcodeSettingStatus === "completed" ? "completed" : "pending", id: 5 },
                { step: "Start Selling Products", status: response.salesStatus === "completed" ? "completed" : "pending", id: 6 },
            ];

            setSteps(updatedSteps);

            // Use the new array instead of state
            const firstIncomplete = updatedSteps.find(step => step.status === "pending");
            if (firstIncomplete) {
                setSelectedRowId(firstIncomplete.id);
            } else if (updatedSteps.length > 0) {
                setIsAllStepCompleted(true);
                // setSelectedRowId(updatedSteps[0].id);
            }

            console.log("updatedSteps", updatedSteps); // This will now show the correct steps
        }  else {
                toast.error(response?.message || "Failed to fetch data");
                console.log("response",response);
            }
        } catch (error) {
            toast.error("Failed to fetch data");
            console.log("error", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchGetStartedData();
    }, []);

    const stepDescription = [
        {
            id: 1,
            title: "Store Setup",
            paragraph: "Set up your store with all the essential details to keep everything organized and running smoothly.",
            points: [
                "Enter unique store code for identification",
                "Set business hours to display timings",
                "Add store location and full address",
                "Upload logo and store images",
                "Update contact details and other preferences"
            ],
            link: "/settings/stores",
            buttonText: "Manage Store Settings",
            iconType: "store"
        },
        {
            id: 2,
            title: "Tax Setup",
            paragraph: "Configure your tax settings to ensure accurate calculations and compliance.",
            points: [
                "Set up tax rates for different regions",
                "Configure tax-inclusive or tax-exclusive pricing",
                "Define tax categories for products",
                "Set up tax exemptions if applicable"
            ],
            link: "/catalogue/taxes",
            buttonText: "Configure Tax",
            iconType: "taxes"
        },
        {
            id: 3,
            title: "Setup Catalogue",
            paragraph: "Create and organize your product catalog for easy management.",
            subSteps: [
                // {
                //     id: 3.1,
                //     title: "Add Categories",
                //     paragraph: "Organize your products by creating categories and subcategories.",
                //     points: [
                //         "Create product categories and subcategories",
                //         "Set up category hierarchy",
                //         "Add category images and descriptions",
                //         "Configure category-specific settings"
                //     ],
                //     link: "/catalogue/category",
                //     buttonText: "Add Categories",
                //     iconType: "category",
                //     statusKey: "categoryStatus"
                // },
                {
                    id: 3.2,
                    title: "Add Products",
                    paragraph: "Add products to your catalog with all necessary details.",
                    points: [
                        "Add individual products with details",
                        "Import products in bulk using templates",
                        "Set up product variants and attributes",
                        "Add product images, descriptions, and pricing"
                    ],
                    link: "/catalogue/product",
                    buttonText: "Add Products",
                    iconType: "catalogue",
                    statusKey: "productStatus"
                }
            ],
            iconType: "catalogue"
        },
        {
            id: 4,
            title: "Stock up your Inventory",
            paragraph: "Manage your inventory levels and track stock movements.",
            points: [
                "Add stock through purchase entries",
                "Update existing product stock quantities",
                "Track stock movements and adjustments",
            ],
            link: "/inventory/inventorylist",
            buttonText: "Manage Inventory",
            iconType: "inventory"
        },
        {
            id: 5,
            title: "Print Setup",
            paragraph: "Configure print template and barcode settings for your stores.",
            points: [
                "Choose the store you want to configure",
                "In top navigation bar",
                "Go to Print Configuration: From this menu, you can edit existing settings or create a new template.",
                "Print Barcode: Configure and print the barcode according to your requirements.",
                "Save settings for the selected store"
            ],
            link: "/settings/stores",
            buttonText: "Manage Print Setup",
            iconType: "print"
        },
        {
    id: 6,
    title: "Start Selling Products",
    paragraph: "You're all set! Start processing sales.",
    points: [
        "Scan or search for products to add to cart",
        "Print receipts and manage sales transactions",
        "View real-time sales reports and analytics"
    ],
    externalLink:true,
    link: "https://billing.posible.in/",
    buttonText: "Start Selling Now",
    iconType: "sales"
}
    ];

    const compressTableColumns = [
        {
            field: "step",
            headerName: "Step",
            flex: 1,
            hideHeaderNameOnMobile: true,
            renderCell: (row) => {
                const { row: stepData } = row;
                const isCompleted = stepData.status === "completed";
                
                return (
                    <div className="flex gap-3 items-center w-full min-w-0 pr-4">
                        {/* Step Number / Status Indicator */}
                        <div className={`w-5 h-5 flex-shrink-0 flex justify-center items-center rounded-full font-medium text-sm ${
                            isCompleted 
                                ? "bg-green-500 text-white" 
                                : "bg-gray-200 text-gray-600"
                        }`}>
                            {isCompleted ? (
                                <span className="w-3 h-3 flex items-center justify-center">
                                    <Icon type="check" />
                                </span>
                            ) : (
                                stepData.id
                            )}
                        </div>

                        {/* Step Name */}
                        <span
                            className={`flex-grow min-w-0`}
                            title={stepData.step}
                        >
                            {stepData.step}
                        </span>
                    </div>
                );
            },
        }
    ];

    // Find the selected step description
    const selectedStep = stepDescription.find(step => step.id === selectedRowId);

    return (
        <SideBySideLayout
            left={
                <DataViewPage
                    isCompress={true}
                    iconType={"flash"}
                    title={"Get Started"}
                >
                    <CustomTable
                        isCompress={true}
                        columns={compressTableColumns}
                        rows={steps}
                        selectedRowId={selectedRowId}
                        noHeader={true}
                        loading={loading}
                        handleOnRow={(row) => {
                            setSelectedRowId(row.id);
                        }}
                    />
                </DataViewPage>
            }
            right={
                <ViewPage
                    name={"Welcome, " + user.Name}
                    handleRemoveBtnClick={() => { navigate(-1) }}
                    description={isMobileView() ? "":"Follow our quick checklist to get started with Posible"}
                       iconButtons={[
                              {
                                label: "Need help ? Click here",
                                onClick: () => window.open("https://posible.in/Help", '_blank'),
                                icon: <Icon type="help" />,
                                tooltipWidth: "200px"
                              },
                             
                            ]}
                >

   {isMobileView() &&  <div className="relative mx-2 bg-white rounded-lg shadow-sm border border-gray-200">
  {/* Header */}
  <div
    className="flex justify-between items-center px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors"
    onClick={() => setIsOpen(!isOpen)}
  >
    <div className="italic text-sm">
      <span className="font-semibold">{(isAllStepCompleted && !selectedStep) ? "All Steps Completed " :"Next Step: "} </span>
      <span>{(isAllStepCompleted && !selectedStep) ? "" : selectedStep?.title }</span>
    </div>

    {/* Toggle icon */}
    <svg
      className={`w-5 h-5 transform transition-transform duration-300 text-[#000000] ${
        isOpen ? "rotate-180" : "rotate-0"
      }`}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </div>

  {/* Dropdown Table content (overlay like select) */}
  {isOpen && (
    <div className="absolute left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50">
      <div className="p-3 max-h-80 overflow-auto">
        <CustomTable
          isCompress={true}
          columns={compressTableColumns}
          rows={steps}
          selectedRowId={selectedRowId}
          noHeader={true}
          loading={loading}
          handleOnRow={(row) => {
            setSelectedRowId(row.id);
            setIsOpen(false);
          }}
        />
      </div>
    </div>
  )}
</div>}

                  {loading ? <Loading/> :  <div>
                    {(isAllStepCompleted && !selectedStep) &&
                    <div className="text-center font-semibold mt-5">You’ve completed all the basic steps! The software is now ready for you to use.</div>
                    

                    }
                        {selectedStep && (
                            <div key={selectedStep.id} className="mb-6 p-4">
                                <h2 className="text-xl font-semibold mb-2">{selectedStep.title}</h2>
                                <p className="mb-2">{selectedStep.paragraph}</p>
                                
                                {selectedStep.subSteps ? (
                                    <div className="space-y-6">
                                       {selectedStep.subSteps.map((subStep) => (
  <div key={subStep.id} className="pl-4 ml-2 py-3">
    <h3 className="text-lg font-medium mb-2">{subStep.title}</h3>
    <p className="mb-2 text-gray-600">{subStep.paragraph}</p>
    <ul className="list-disc list-inside mb-3">
      {subStep.points.map((point, i) => (
        <li key={i} className="mb-1">{point}</li>
      ))}
    </ul>
    <Button
      type="primary"
      iconType={subStep.iconType}
      onClick={(e) => {
        if (subStep?.externalLink) {
          e.preventDefault();
          window.open(subStep.link, "_blank");
          return; // ✅ stop further execution
        }
        navigate(subStep.link);
      }}
    >
      {subStep.buttonText}
    </Button>
  </div>
))}

                                    </div>
                                ) : (
                                    <>
                                        <ul className="list-disc list-inside mb-3">
                                            {selectedStep.points.map((point, i) => (
                                                <li key={i} className="mb-1">{point}</li>
                                            ))}
                                        </ul>
                                          <Button
      type="primary"
      iconType={selectedStep.iconType}
      onClick={(e) => {
        if (selectedStep?.externalLink) {
          e.preventDefault();
          window.open(selectedStep.link, "_blank");
          return; // ✅ stop further execution
        }
        navigate(selectedStep.link);
      }}
    >
      {selectedStep.buttonText}
    </Button>
                                      
                                    </>
                                )}
                            </div>
                        )}
                    </div>}
                </ViewPage>
            }
        />
    );
};

export default GetStarted;